/* eslint-disable react/no-deprecated */
import React from 'react';
import ReactDOM from 'react-dom';
import { registerLicense } from '@syncfusion/ej2-base';
import App from './App';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

const rootElement = document.getElementById('root');

registerLicense('Mgo+DSMBaFt8QHJqU01hXk5Hd0BLVGpAblJ3T2ZQdVt5ZDU7a15RRnVeQF1gSHhXf0VrXXxfcg==');

ReactDOM.render(<App />, rootElement);
